import m from "mithril"
import "./css/main.css"
import { Home } from "./views/Home.js"

m.route(document.getElementById("app"), "/", {
  "/": Home,
  "/project/:id": Home,
})
